// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"556":"ea6f7ac7","623":"abcf457b","787":"cdb5da12"}[chunkId] + ".chunk.js";
};